import AppStore from './components/AppStore';
import './App.css';

function App() {
  return (
    <div className="App">
      <AppStore/>
    </div>
  );
}

export default App;
